import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductListPageRBAC = {
  pageID: '2cc7d08a47f031ce74d678bd6e9ad82e',
  elementID: {
    ViewPage: 'b49fd0b5657add78f006b02bd21a3992',
    CreateProduct: 'e04ca79432584d2e5f9a249b95bd7f3f',
    ActionDetailProduct: '937a137ff046283de17b09a53143b80e',
    ActionVendorList: '4626b327e6bd7bc97cd07577e3df4bee',
    ActionPackageStructure: 'cb46b49b001530d618367ce23e1a486f',
    UpdateProductStatus: '7b00bfbcfd56412184eae2199cb9374c',
    BulkUploadProductMaster: 'fcb1df33cd82f5cca7d2ef0600fb72e6',
    BulkUploadPackageStructure: 'a85015beb68e4a47a02f7c50300bbe00',
    BulkUploadProductCatalogue: 'a8a05eebf65cd86a0ef14b71fb75d987',
    ActionAturSEO: '80c4c0f22ac5b794fc7a4911188af031',
  },
} as const

export const useRBACProductListPage = createUseRBAC(ProductListPageRBAC.elementID)

export type UseRBACProductListPageType = ReturnType<typeof useRBACProductListPage>
